import React, { useEffect, useState } from 'react'
import TitleHead from '../../../components/Customs/TitleHead'
import { Card, Table, Button, Input, InputNumber, Empty  } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { RoomServices } from '../../../Services/RoomServices'
import { notify } from '../../../components/Customs/NotifyProvider'
import { GeneralService } from '../../../Services/GeneralService'

import { canViewModule, canUpdateModule } from '../../../../utils/permissionUtils';

const MODULE_KEY = "loyalty_programme";

const LoyaltyProg = () => {
    const [values, setValues] = useState({
        // checkin: dayjs('09:00 AM', 'hh:mm A'),
        // checkout: dayjs('06:00 PM', 'hh:mm A'),
    })

    const [originalValues, setOriginalValues] = useState(values)
    const [isChanged, setIsChanged] = useState(false)
    const [changedRows, setChangedRows] = useState({})

    const getDefaultVal = async () => {
        try {
            const req = await RoomServices.getAllByTable('utills');

            const defaultData = {
                loyalty_count: req.data[0].loyalty_count || '',
                loyalty_dis: req.data[0].loyalty_dis || '',
            };

            setValues(defaultData);
            setOriginalValues(defaultData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getDefaultVal();
    }, [])

    const handleChange = (key, value) => {
        setValues(prev => ({
            ...prev,
            [key]: value,
        }));

        setChangedRows(prev => ({
            ...prev,
            [key]: value !== originalValues?.[key],
        }));
    };

    const handleRowSave = async (record) => {
        const payload = {
            [record.keyName]: values[record.keyName],
        };

        console.log('Saving:', record.keyName);
        console.log('Payload:', payload);

        const req = await GeneralService.update('utills', 6, payload);

        if (req.status) {
            notify.success(`${record.label} updated successfully`);

            setOriginalValues(prev => ({
                ...prev,
                [record.keyName]: values[record.keyName],
            }));

            setChangedRows(prev => ({
                ...prev,
                [record.keyName]: false,
            }));
        } else {
            notify.error('Something went wrong!', req.message);
        }
    };
    const columns = [
        {
            title: 'S.No',
            key: 'sno',
            align: 'center',
            render: (_, __, index) => index + 1,
        },
        {
            title: 'Setting',
            dataIndex: 'label',
            key: 'label',
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            render: (_, record) => (
                <InputNumber
                    style={{ width: '100%' }}
                    min={0}
                    value={values[record.keyName]}
                    onChange={(value) => handleChange(record.keyName, value)}
                    placeholder="Enter value"
                />
            ),
        },
        {
            title: 'Action',
            key: 'action',
            align: 'center',
            render: (_, record) => (
          <Button
    type="primary"
    icon={<SaveOutlined />}
    disabled={!changedRows[record.keyName] || !canUpdateModule(MODULE_KEY)}
    onClick={() => handleRowSave(record)}
>
    Save
</Button>
            ),
        },
    ]

    const data = [
        {
            key: '1',
            label: 'Minimum number of bookings required to earn membership points',
            keyName: 'loyalty_count',
        },
        {
            key: '2',
            label: 'Loyalty Customer Discount (%)',
            keyName: 'loyalty_dis',
        },

    ]

        if (!canViewModule(MODULE_KEY)) {
        return <Empty description="No permission to view this page" />;
    }

    return (
        <Card
            title={
                <TitleHead
                    h1="Loyalty Program"
                    h2="Manage customer rewards, loyalty points, membership benefits, and engagement activities."
                />
            }

        >
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                bordered
                
            />
        </Card>
    )
}

export default LoyaltyProg
